import React from 'react';
import PropTypes from 'prop-types';

export default function ShowAt({ at, children }) {
  return <>{!!at && children}</>;
}

ShowAt.defaultProps = {
  at: false,
  children: <></>,
};

ShowAt.propTypes = {
  at: PropTypes.bool,
  children: PropTypes.node,
};
